module.exports = __webpack_public_path__ + "img/logo-zgpa.d401e6eb.png";